const ItemWork = ({ content }) => {

	const contents = content;
	const className = `work-main__item item-work-item item-work-item_${content.id}`;


	return (
		<div className={className}>
			<div className="item-work-item__body">
				<div className="item-work-item__id">{contents.id}</div>
				<div className="item-work-item__text">{contents.text}</div>
			</div>
		</div>
	)

}

export default ItemWork;